var MenuProfile = (function () {
    var mainMenuId = 0;
    var mainMenu = [];
    var subMenu = [];
    var statMenu = [];
    var getMainMenuIdProfile = function () {
        return mainMenuId;
    }
    var getMainMenuProfile = function () {
        return mainMenu;
    }
    var getSubMenuProfile = function () {
        return subMenu;
    }
    var getStatMenuProfile = function () {
        return statMenu;
    }
    var setMainMenuIdProfile = function (id) {
        mainMenuId = id;
    }
    var setMainMenuProfile = function (main) {
        mainMenu = main;
    }
    var setSubMenuProfile = function (sub) {
        subMenu = sub;
    }
    var setStatMenuProfile = function (stat) {
        statMenu = stat;
    }
    return {
        getMainMenuId: getMainMenuIdProfile,
        getMainMenu: getMainMenuProfile,
        getSubMenu: getSubMenuProfile,
        getStatMenu: getStatMenuProfile,
        //set--->
        setMainMenuId: setMainMenuIdProfile,
        setMainMenu: setMainMenuProfile,
        setSubMenu: setSubMenuProfile,
        setStatMenu: setStatMenuProfile
    }
})();
export default MenuProfile;